<template>
  <div class="searchbox-wrapper">
    <input
      type="text"
      class="form-control"
      v-model="searchQuery"
      :placeholder="placeholder"
      :class="{ 'with-icon': isWithIcon }"
      :style="{ width }"
      @keyup.enter="handleSearch"
      @blur="handleBlur"
    />
    <div class="icon-wrapper clear" v-show="searchQuery" @click="clearQuery">
      <fa icon="times-circle"></fa>
    </div>
    <div
      v-if="isWithIcon"
      v-show="!searchQuery"
      class="icon-wrapper search"
      @click="handleSearch"
    >
      <fa icon="search" class="icon"></fa>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    isWithIcon: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Input search keyword'
    },
    isSearchingInRealTime: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: 'auto'
    },
    defaultQuery: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchQuery: ''
    };
  },
  computed: {},
  methods: {
    handleSearch() {
      this.$emit('onSearch', this.searchQuery);
    },
    handleBlur() {
      this.handleSearch();
    },
    clearQuery() {
      this.searchQuery = '';
    }
  },
  watch: {
    searchQuery(val, prevVal) {
      if (!this.isSearchingInRealTime) return;

      // Debounce handleSearch
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.handleSearch();
      }, 300);
    }
  },
  mounted() {
    if (this.defaultQuery) this.searchQuery = this.defaultQuery;
  }
};
</script>

<style lang="scss" scoped>
.searchbox-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

  .with-icon {
    padding-right: 2rem;
  }

  .icon-wrapper {
    position: absolute;
    right: 0;
    width: 2rem;
    text-align: center;
    cursor: pointer;
    color: $text-grey;

    &:hover {
      color: $icon-grey;
    }
  }
}
</style>
